import { useEffect, useRef } from 'react'
import { useCompanyTimeZone } from 'components/common/hooks/useCompanyTimeZone'
import { captureDashboardViewed } from './events'

function useDashboardViewed(dashboardName, period) {
  const { companyTimeZone } = useCompanyTimeZone()
  const reportedDashboardName = useRef(null)

  useEffect(() => {
    const periodIsKnown = Boolean(period?.from && period?.to)
    const alreadyReported = reportedDashboardName.current === dashboardName
    if (!dashboardName || !periodIsKnown || alreadyReported) {
      return
    }

    captureDashboardViewed(dashboardName, companyTimeZone, period)
    reportedDashboardName.current = dashboardName
  }, [dashboardName, period, companyTimeZone])
}

export { useDashboardViewed }
